export enum BatchDetailsScreen {
  PART = 'BatchDetailsPart',
  JOBS = 'BatchDetailsJobs',
  BATCH = 'BatchDetailsBatch',
  NC_FILE = 'BatchDetailsNCFile',
  TOOLS = 'BatchDetailsTools',
}

export enum BatchDetailsScreenLink {
  PART = 'part',
  BATCH = 'batch',
  NC_FILE = 'nc-file',
  JOBS = 'jobs',
  TOOLS = 'tools',
}

export enum BatchLevelSubScreen {
  GENERAL = 'General',
  TIMELINE = 'Timeline',
  TIMES = 'Times',
  // VERSIONS = 'Versions',
  DOCUMENTS = 'Documents',
}

export enum BatchLevelSubScreenLink {
  GENERAL = 'general',
  TIMELINE = 'timeline',
  TIMES = 'times',
  // VERSIONS = 'Versions',
  DOCUMENTS = 'documents',
}
